import { showSuccess, showError } from '../../index.js'

export default {
  namespaced: true,
  state () {
    return {
      permissions: []
    }
  },
  getters: {
    backendPermissions (state) {
      return state.permissions.filter(item => item.deleted_at === null)
    },
    getClientsidePermission (state) {
      return state.permissions
        .filter(item => item.permission_name.toLowerCase().includes('docs'))
        .map(item => ({ id: item.id, name: item.permission_name }))
    }
  },
  mutations: {
    setPermissions (state, payload) {
      state.permissions = payload
    }
  },
  actions: {
    async getPermissionData (context) {
      await context.rootState.authAxios.get('/Permissions').then((response) => {
        context.commit('setPermissions', response.data)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postPermission (context, payload) {
      await context.rootState.authAxios.post('/Permissions',
        payload
      )
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updatePermission (context, payload) {
      await context.rootState.authAxios.put(`/Permissions/Update/${payload.id}`,
        payload
      )
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deletePermission (context, payload) {
      await context.rootState.authAxios.put(`/Permissions/DeletePermission/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    }
  }
}
